import React from "react";

// Empty-state icon for Settings › Facilities — the facilities glyph (Figma "Icons/Hospital", same path
// as FacilityIcon) centered in the Primary-50 circle of the Table/State=Empty component.
const EmptyFacilityListIcon = ({ style = {} }) => {
  return (
    <svg style={style} width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="48" height="48" rx="24" fill="#EFF8FF" />
      <g transform="translate(12 12)">
        <path
          d="M4.96317 21V9.686C4.96317 9.384 5.19837 9.138 5.48925 9.138H7.06557C7.20492 9.138 7.33859 9.0804 7.43722 8.97785C7.53585 8.87529 7.59139 8.73616 7.59165 8.591V5.122C7.59165 4.819 7.82685 4.574 8.11773 4.574H15.8265C16.1164 4.574 16.3516 4.819 16.3516 5.122V8.59C16.3516 8.892 16.5868 9.137 16.8777 9.137H18.454C18.7449 9.137 18.9801 9.383 18.9801 9.685V21.001M11.9702 4.573V3M20.16 21H3.78333M9.82173 17.484L9.82365 17.538M9.82173 14.285L9.82365 14.339M14.2694 17.484L14.2675 17.538M14.2694 14.285L14.2675 14.339M11.9712 9.431V11.101M11.9712 9.431V7.761M11.9712 9.431H13.5734M11.9712 9.431H10.3689"
          stroke="#1570EF"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export default EmptyFacilityListIcon;
